import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import { deletes, get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../redux/api/PermissionManager";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import Select from "react-select";
import DateRange from "../../../components/DateRange/DateRange";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../../components/StaticData";

const PropertyBanner = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    state: "",
    search: paginationData?.[path]?.search ?? "",
  });
  const [optionsList, setOptionsList] = useState({
    states: [],
    cities: [],
  });

  const [list, setList] = useState([]);
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    getLocationsList(2);
    getCities();
    // fetch();
  }, []);

  //get  locations
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    console.log("locations list", res, type, parent_id);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setOptionsList((prev) => ({ ...prev, states: modifiedList }));
      } else if (type === 3) {
        setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
      } else {
        setOptionsList((prev) => ({ ...prev, areas: modifiedList }));
      }
    }
  };

  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.city, selectedFilter.state, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { city, from, state, search, to } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 2);
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (state) {
      payload.append("state", state?.value);
    }
    const res = await post(URLS.BANNERS + "?page=" + pageNumber, payload);
    console.log("property Banners", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data);
    }
  };

  const handleStatus = async (id, status) => {
    if (!checkPermission("CAN-STATUS-BANNER")) return;
    let res = await post(`${URLS.BANNER_MASTER}${id}/status/`, {
      status: status ? 0 : 1,
    });
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const handleDelete = async (id) => {
    let res = await deletes(`${URLS.BANNER_MASTER}${id}/delete/`);
    if (res?.status === "success") {
      setPopup(false);
      toast.success("Role Deleted Successfully");
      getList();
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
        },
      },
      {
        Header: "Image",
        accessor: "image",
        Cell: ({ value, row }) => {
          return (
            <img
              alt="not found"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "10px",
              }}
              src={Boolean(value) ? value : dummyimage}
            />
          );
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          const states = row?.original?.states?.map((ele) => ele?.name) || [];

          return (
            <div>
              {row?.original?.all_states ? (
                <p>All States</p>
              ) : (
                <div>
                  {states.map((stateName, index) => (
                    <p key={index}>{stateName}</p>
                  ))}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "City",
        accessor: "city",

        Cell: ({ value, row }) => {
          const citys = row?.original?.cities?.map((ele) => ele?.name) || [];
          return (
            <div>
              {row?.original?.cities.length == 0 ||
              row?.original?.states.length > 1 ? (
                <p>All City</p>
              ) : (
                <div>
                  {/* {citys.map((stateName, index) => ( */}
                  <p>{citys.length}</p>
                  {/* ))} */}
                </div>
              )}
            </div>
            // <p>
            //   {
            //     ? "All City"
            //     : value}
            // </p>
          );
        },
        // Cell: ({ value, row }) => {
        //   return <p>{value}</p>;
        // },
      },
      {
        Header: "Count",
        accessor: "count",
        Cell: ({ value, row }) => {
          return <p>1</p>;
        },
      },
      {
        Header: "From Date",
        accessor: "start_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "To Date",
        accessor: "end_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original.id, value);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            {checkPermission("CAN-EDIT-BANNER") && (
              <div className="d-flex ac-js gap-3">
                <button
                  onClick={() => {
                    navigate("/add-property-banners", {
                      state: { type: "edit", data: row.original },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit_icon} alt="" className=" edit-btn " />
                </button>
                {checkPermission("CAN-DELETE-BANNER") && (
                  <button
                    onClick={() => setPopup(row.original.id)}
                    className="cust-btn "
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            )}
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-EDIT-BANNER") ||
      checkPermission("CAN-DELETE-BANNER")
      ? [...d, action]
      : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Banner"} subHead={"Property Banner"} />

      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.states}
          isClearable
          onChange={(e) => {
            handleChangeFilter("state", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.state}
          placeholder={"State"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        {checkPermission("CAN-ADD-BANNER") && (
          <button
            onClick={() =>
              navigate("/add-property-banners", {
                state: { type: "add" },
              })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add New
          </button>
        )}
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={false}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(popup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default PropertyBanner;
